export enum NotificationStateEnum {
    default,
    success,
    error,
}
